<template>
  <div :id="id" class="collapse">
    <div class="tw-rounded-md tw-bg-red-50 tw-py-2.5 tw-px-4 sm:tw-py-4 sm:px-6">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex">
          <div class="tw-flex tw-items-center">
            <alert-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
          </div>
          <div class="tw-ml-4 tw-text-red-600">
            <div class="tw-font-xl ">{{ title }}</div>
            <div class="tw-font-thin tw-text-sm tw-text-red-500">{{ message }}</div>
            <button
              class="tw-text-xs tw-underline tw-mt-1 tw-cursor-pointer hover:tw-text-red-400 tw-transition-colors tw-duration-100"
              data-toggle="collapse"
              data-target="#inlineErrorDetails"
            >
              View Details
            </button>
            <div class="collapse" id="inlineErrorDetails">
              <ul class="tw-text-xs tw-font-thin tw-text-red-500">
                <li>{{ detailedErrorMessage }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tw-flex tw-items-center tw-ml-4">
          <button data-toggle="collapse" :data-target="`#${id}`">
            <x-icon class="tw-h-6 tw-w-6 tw-text-red-600 tw-cursor-pointer" aria-label="Dismiss" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertIcon from "@/assets/svgs/alert-icon.svg";
import XIcon from "@/assets/svgs/x-icon.svg";
import $ from "jquery";
import errormessage from "@/mixins/errormessage";

export default {
  components: {
    AlertIcon,
    XIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Error With this action",
    },
    message: {
      type: String,
      default: "There was an error with this action. please try again.",
    },
    error: {
      type: [Object, Error],
    },
  },
  computed: {
    detailedErrorMessage() {
      return this.error ? this.getErrorMessage(this.error) : "No Details Available :(";
    },
  },
  mixins: [errormessage],
  watch: {
    title(newValue, oldValue) {
      if (!newValue && oldValue) {
        $(`#${this.id}`).collapse("hide");
      } else {
        $(`#${this.id}`).collapse("show");
      }
    },
    message(newValue, oldValue) {
      if (!newValue && oldValue) {
        $(`#${this.id}`).collapse("hide");
      } else {
        $(`#${this.id}`).collapse("show");
      }
    },
    error(newValue) {
      $(`#${this.id}`).collapse("show");
      if (newValue) throw newValue;
    },
  },
};
</script>
